import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IPartner, IPartnerState } from "./types";

const initialPartner: IPartner = {
  recordId: 0,
  businessCustomerName: "",
  businessCustomerNumber: 0,
  businessCustomerStartDate: "",
  businessCustomerEndDate: "",
  createdby: "",
  createdon: "",
  lastUpdateBy: null,
  lastUpdateOn: null,
  isEligible: false,
};

const initialState: IPartnerState = {
  selectedPartner: initialPartner,
  partnersList: [],
  totalRecords: 0,
  pageNumber: 0,
  pageSize: 0,
  totalPages: 0,
};

export const partnerSlice = createSlice({
  name: "partner",
  initialState,
  reducers: {
    setPartnerInfo: (state, action: PayloadAction<IPartner>) => {
      state.selectedPartner = action.payload;
    },
    setPartnersListData: (
      state,
      action: PayloadAction<{
        data: IPartner[];
        totalRecords: number;
        pageNumber: number;
        pageSize: number;
        totalPages: number;
      }>,
    ) => {
      state.partnersList = action.payload.data;
      state.totalRecords = action.payload.totalRecords;
      state.pageNumber = action.payload.pageNumber;
      state.pageSize = action.payload.pageSize;
      state.totalPages = action.payload.totalPages;
      // Set first partner as selected if available
      if (action.payload.data.length > 0) {
        state.selectedPartner = action.payload.data[0];
      }
    },
    setBusinessCustomerNumber: (state, action: PayloadAction<number>) => {
      state.selectedPartner.businessCustomerNumber = action.payload;
    },
    setBusinessCustomerName: (state, action: PayloadAction<string>) => {
      state.selectedPartner.businessCustomerName = action.payload;
    },
    setIsEligible: (state, action: PayloadAction<boolean>) => {
      state.selectedPartner.isEligible = action.payload;
    },
    clearPartnerInfo: () => {
      return initialState;
    },
  },
});

export const {
  setPartnerInfo,
  setPartnersListData,
  setBusinessCustomerNumber,
  setBusinessCustomerName,
  setIsEligible,
  clearPartnerInfo,
} = partnerSlice.actions;

export default partnerSlice.reducer;
